import * as React from 'react'
import mapStore from '../../../store/mapStore.ts'
import { clearRoute, doRoute } from './directionHelper.tsx'

export const MobileDirections: React.FC = () => {
    const map = mapStore(s => s.map)
    const myPosition = mapStore(s => s.myPosition)
    const directionsTo: google.maps.LatLng | null = mapStore(s => s.directionsTo)
    const travelMode = mapStore(s => s.travelMode)

    React.useEffect(() => {
        return () => {
            setTimeout(() => clearRoute())
        }
    }, [])

    React.useEffect(() => {
        if (myPosition && directionsTo) {
            void doRoute(map, travelMode, myPosition, directionsTo)
        }
    }, [myPosition, directionsTo])

    return null
}
